export default function addStatFilters(self, fields) {
  // const statDefinedFields = [
  //   {
  //     title: "User",
  //     key: "p",
  //     type: "reference",
  //     referenceType: "persona",
  //     minimum: 1,
  //     maximum: 0,
  //   },
  //   {
  //     title: "Key",
  //     key: "k",
  //     type: "string",
  //     minimum: 1,
  //     maximum: 0,
  //   },
  // ];

  //////////////////////////////////////////

  // const fieldGroupItems = {
  //   title: ``,
  //   minimum: 1,
  //   maximum: 1,
  //   key: "items[]",
  //   asObject: true,
  //   type: "group",
  //   fields: [...statDefinedFields],
  // };

  const StatField = {
    title: `Reactions & activity`,
    minimum: 1,
    maximum: 1,
    key: "join_stats",
    asObject: true,
    type: "group",
    fields: [
      {
        title: "All",
        minimum: 1,
        maximum: 1,
        key: "total",
        type: "integer",
        referenceType: "stat",
      },
    ],
  };

  fields.push(StatField);
}
